export default "__VITE_ASSET__DRPsuAwm__"